module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div-container', [_c('div', {
    staticClass: "columns content is-centered is-gapless is-flex-mobile is-multiline",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-offset": "-30"
    }
  }, [_c('p', {
    staticClass: "column is-8 is-12-touch copyright-wrapper is-hidden-touch"
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + " BOSS HOG COOK-OFF. All Rights Reserved. Website by "), _c('a', {
    attrs: {
      "href": "http://adaptconcepts.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "border-bottom": "1px solid black"
    }
  }, [_vm._v("Adapt Concepts")])])]), _vm._v(" "), _c('p', {
    staticClass: "column is-4 is-12-touch social-wrapper"
  }, [_c('span', {
    staticClass: "social"
  }, [_vm._v("Follow us on social media")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navFacebook.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navTwitter.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "column is-8 is-12-touch copyright-wrapper is-hidden-desktop"
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + " BOSS HOG COOK-OFF. All Rights Reserved. Website by "), _c('a', {
    attrs: {
      "href": "http://adaptconcepts.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "border-bottom": "1px solid black"
    }
  }, [_vm._v("Adapt Concepts")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e9e53c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 911
// module chunks = 1